"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageBreadcrumbs = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const Breadcrumb_1 = require("./Breadcrumb");
const Breadcrumbs_1 = require("./Breadcrumbs");
const util_1 = require("../../6-page/DocsPages/util");
const PageBreadcrumbs = ({ page, steps }) => {
    const crumbs = [];
    const pages = util_1.pageutils.walk(page, steps);
    const length = pages.length;
    const last = length - 1;
    for (let i = 0; i <= last; i++) {
        const curr = pages[i];
        crumbs.push(React.createElement(Breadcrumb_1.Breadcrumb, { key: curr.to + '', to: curr.to || '/', noHover: i === last }, curr.name || curr.title || curr.id || ''));
    }
    return React.createElement(Breadcrumbs_1.Breadcrumbs, { crumbs: crumbs });
};
exports.PageBreadcrumbs = PageBreadcrumbs;
